// extracted by mini-css-extract-plugin
export default {"statusUpdate":"styles_statusUpdate__OYSga","label":"styles_label__RTOcI","dropdown":"styles_dropdown__BQEQ1","pending":"styles_pending__8enFm"};